// MetricCard — compact stat tile (label + value + optional sub-line). Lighter
// than KpiCard (no trend, smaller). For dense stat rows in Portfolio/Manage.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './metric-card.css';

export function MetricCard({ label, value, sub, tone, align = 'left', className }) {
  return (
    <div className={cx('metric-card', `metric-card--${align}`, tone && `metric-card--${tone}`, className)}>
      <span className="metric-card__label">{label}</span>
      <span className="metric-card__value">{value}</span>
      {sub && <span className="metric-card__sub">{sub}</span>}
    </div>
  );
}

MetricCard.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  sub: PropTypes.node,
  tone: PropTypes.oneOf(['gain', 'loss', 'muted']),
  align: PropTypes.oneOf(['left', 'center', 'right']),
  className: PropTypes.string,
};

export default MetricCard;
